import { ListItem, ListItemText } from '@mui/material';
import { bytesToMb, translations } from '../../lib';
import { Delete } from '@mui/icons-material';

export type DocumentItemProps = {
    uploadedFile: any;
    index: string;
    deleteFileHandler: (option: string) => void;
};

const DocumentItem = ({ uploadedFile, index, deleteFileHandler }: DocumentItemProps) => {
    return (
        <ListItem
            key={index}
            id={uploadedFile.value.name}
            sx={{
                border: '2px solid lightgrey',
                borderRadius: '5px',
                margin: '10px 0',
                padding: '3px 8px',
            }}
        >
            <ListItemText primary={uploadedFile.value.name} />
            {bytesToMb(uploadedFile.value.size, 1)}
            {translations.documentation.DOCUMENTATION_MB}
            <Delete
                color="primary"
                onClick={() => deleteFileHandler(uploadedFile.value.name)}
                style={{ cursor: 'pointer' }}
            />
        </ListItem>
    );
};

export default DocumentItem;
